<template>
  <div class="page">
    <header-bar navStyle="padding-left:.266rem;padding-right:.266rem;">
      <span>{{ $t(objSave.centerTitle) }}</span>
      <span slot="right" @click="saveInfos">{{ $t('share.Save') }}</span>
    </header-bar>
    <div class="page-content">
      <div class="addInvoice-wrapper">
        <div class="addInvoice-item">
          <div @click="SelectType('0')">
            <span style="display:inline-blocks;width:2rem">{{ model.InvoiceRole | mapTitle("InvoiceRole") }}</span>
            <img src="/static/img/left1.png" />
          </div>
          <div>{{ $t("mall.InvoiceRole") }}:</div>
        </div>
        <div class="border_bottom"></div>
        <div class="addInvoice-item">
          <div @click="SelectType('1')">
            <span style="display:inline-blocks;width:2rem">{{ model.InvoiceType | mapTitle("InvoiceType") }}</span>
            <img src="/static/img/left1.png" />
          </div>
          <div>{{ $t("mall.InvoiceType") }}:</div>
        </div>
        <div class="border_bottom"></div>
        <div class="addInvoice-item">
          <div>
            <input type="text" :placeholder="$t('placeholders.Invoice')" v-model="model.InvoiceTitle" />
          </div>
          <div>{{ $t("mall.Invoice") }}:</div>
        </div>
        <div v-if="model.InvoiceRole == 1813 && model.InvoiceType == 1821">
          <div class="border_bottom"></div>
          <div class="addInvoice-item">
            <div>
              <input type="text" :placeholder="$t('placeholders.Identifier')" v-model="model.IdentifyNumber" />
            </div>
            <div>{{ $t("mall.Identifier") }}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="addInvoice-item">
            <div>
              <input type="text" :placeholder="$t('placeholders.BankName')" v-model="model.BankName" />
            </div>
            <div>{{ $t("mall.BankName") }}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="addInvoice-item">
            <div>
              <input type="text" :placeholder="$t('placeholders.BankAccount')" v-model="model.BankAccount" />
            </div>
            <div>{{ $t("mall.BankAccount") }}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="addInvoice-item">
            <div>
              <input type="text" :placeholder="$t('placeholders.RegisteredAddress')" v-model="model.CompanyAddress" />
            </div>
            <div>{{ $t("mall.RegisteredAddress") }}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="addInvoice-item">
            <div>
              <input type="text" :placeholder="$t('placeholders.RegisteredPhone')" v-model="model.CompanyPhone" />
            </div>
            <div>{{ $t("mall.RegisteredPhone") }}</div>
          </div>
        </div>
      </div>
      <div class="delectInvoice" v-if="model.InvoiceID" @click="delectInvoice">{{$t('system_mall_addinvoice_shanchu')}}</div>
      <!-- <img @click="delectInvoice" :src="$t('system_mall_addinvoice_shanchu')" /> -->
    </div>
    <picker @select="handleSelect(0, arguments)" ref="picker0" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt"></picker>
    <picker @select="handleSelect(1, arguments)" ref="picker1" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt"></picker>
  </div>
</template>
<script>
  import picker from "../modules/picker.vue";
  // import servicetype from "../servicetype.js";
  import navBar from "../modules/navBar.vue";
  import enumUtils from "@/utils/enumUtils";
  import { Categorys } from "@/model/Base";
  import UserService from "@/service/UserService";
  export default {
    name: "addInvoice",
    data() {
      return {
        objSave: {
          centerTitle: "mall.AdditionalInvoiceInformation",
          rightTitle: {
            isShow: true,
            type: "button",
            label: "share.confirmTxt",
            fnName: "fnSave",
          },
        },
        lists: [],
        model: {
          RoleID: "",
          InvoiceID: "",
          InvoiceRole: 1815,
          InvoiceType: 1823,
          IdentifyNumber: "",
          BankName: "",
          BankAccount: "",
          CompanyAddress: "",
          CompanyPhone: "",
        },
        cancelTxt: "share.cancelTxt",
        confirmTxt: "share.confirmTxt",
        selectedText: [],
      };
    },
    computed: {
      InvoiceRoles() {
        return enumUtils.makeCategorys(Categorys.InvoiceRole);
      },
      InvoiceTypes() {
        return enumUtils.makeCategorys(Categorys.InvoiceType);
      },
      InvoiceID() {
        return this.$route.query.InvoiceID;
      },
      UserID() {
        return this.profile.UserID;
      },
      InvoiceTypeDatas() {
        let __self = this;
        let data = _.clone(__self.InvoiceTypes);
        if (__self.model.InvoiceRole == 1815) {
          _.remove(data, o => o.CategoryID == 1821);
          return data;
        } else {
          return __self.InvoiceTypes;
        }
      },
    },
    mounted() {
      let __self = this;
      if (__self.InvoiceID) {
        __self.__init();
      }
      __self.InvoiceRoleData();
      __self.RoleTypeData();
    },
    watch: {
      "model.InvoiceRole"(newval) {
        let __self = this;
        __self.RoleTypeData();
      },
    },
    methods: {
      InvoiceRoleData() {
        let __self = this;
        for (let i = 0; i < __self.InvoiceRoles.length; i++) {
          let InvoiceRole = __self.InvoiceRoles[i];
          InvoiceRole.label = InvoiceRole.CategoryTitle;
          InvoiceRole.value = InvoiceRole.CategoryID;
          if (__self.model.InvoiceRole == InvoiceRole.value) {
            __self.$refs.picker0.setSelectedIndex([i]);
            __self.selectedText.push(InvoiceRole);
          }
        }
        __self.$refs.picker0.setData([__self.InvoiceRoles]);
      },
      RoleTypeData() {
        let __self = this;
        if (__self.model.InvoiceRole == 1815) {
          __self.model.InvoiceType = 1823;
        }
        for (let i = 0; i < __self.InvoiceTypeDatas.length; i++) {
          let InvoiceType = __self.InvoiceTypeDatas[i];
          InvoiceType.label = InvoiceType.CategoryTitle;
          InvoiceType.value = InvoiceType.CategoryID;
          if (__self.model.InvoiceType == InvoiceType.CategoryID) {
            __self.$refs.picker1.setSelectedIndex([i]);
            __self.selectedText.push(InvoiceType);
          }
        }
        __self.$refs.picker1.setData([__self.InvoiceTypeDatas]);
      },
      __init() {
        let __self = this;
        let data = {};
        data.RoleID = __self.UserID;
        data.InvoiceID = __self.InvoiceID;
        UserService.getInvoiceList(data).then(json => {
          if (json.isSucc) {
            __self.model = json.result.entities[0];
            __self.InvoiceRoleData();
          }
        });
      },
      handleSelect(index, args) {
        let __self = this;
        __self.selectedText.splice(index, 1, args[2][0]);
        __self.model.InvoiceRole = __self.selectedText[0].value;
        __self.model.InvoiceType = __self.selectedText[1].value;
      },
      SelectType(index) {
        let __self = this;
        let picker = __self.$refs["picker" + index];
        picker.show();
      },
      back() {
        history.back();
      },
      delectInvoice() {
        let __self = this;
        if (__self.InvoiceID) {
          __self.model.InvoiceID = __self.InvoiceID;
        }

        this.$dialog
          .confirm({
            title: "",
            message: __self.$t("share.confirm.YesOrNoDelect"),
          })
          .then(() => {
            UserService.deleteInvoiceInfo(__self.model.InvoiceID).then(json => {
              if (json.isSucc) {
                this.$root.$toast.success(__self.$t("share.succ.DeleteSucc"));
                history.back();
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      },
      saveInfos() {
        let __self = this;
        if (__self.InvoiceID) {
          __self.model.InvoiceID = __self.InvoiceID;
        }
        __self.model.RoleID = __self.UserID;
        UserService.saveInvoiceInfo(__self.model).then(json => {
          if (json.isSucc) {
            if (__self.model.InvoiceID == "") {
              this.$root.$toast.success(__self.$t("share.succ.AddSucc"));
            } else {
              this.$root.$toast.success(__self.$t("share.succ.ModifySucc"));
            }
            history.back();
          }
        });
      },
    },
    components: {
      navBar,
      picker,
    },
  };
</script>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }
  .page-content {
    top: 2.12rem;
  }

  .addInvoice-wrapper {
    padding: 0 0.266rem;
    background-color: #fff;
  }

  .addInvoice-item {
    position: relative;
  }

  .addInvoice-item > div {
    height: 1.197rem;
    line-height: 1.197rem;
  }

  .addInvoice-item > div:first-child {
    margin-left: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
  }

  .addInvoice-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    min-width: 2.3rem;
    text-align: left;
  }

  .addInvoice-item img {
    width: 0.372rem;
  }

  .addInvoice-item input,
  .addInvoice-item textarea {
    border: none;
    width: 100%;
    height: 100%;
  }

  .addInvoice-item textarea {
    padding: 0;
  }

  .delectInvoice {
    text-align: center;
    background-color: #12a3ff;
    margin: 0.798rem auto;
    width: 7.98rem;
    height: 1.064rem;
    line-height: 1.064rem;
    color: #fff;
    border-radius: 0.106rem;
  }

  .delectInvoice img {
    height: 0.638rem;
  }
</style>
